import { RouterProvider } from "react-router";
import { SessionGate } from "@core/auth";
import { Providers } from "./providers";
import { createRouter } from "./router";

const router = createRouter();

export const App = () => (
  <Providers>
    <SessionGate>
      <RouterProvider router={router} />
    </SessionGate>
  </Providers>
);
